/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum MaterialListMaterialErrorEnum {
    MATERIAL_NOT_FOUND = 'orcan.specialorders.specialorder.material.validation.material.not-found',
    MATERIAL_INACTIVE = 'orcan.specialorders.specialorder.material.validation.material.not-active'
}
